module.exports = __webpack_public_path__ + "img/c7.21236a85.png";